import React, { useEffect, useState } from 'react';
import { InfoWindow, Map, Marker, useMarkerRef } from '@vis.gl/react-google-maps';
import { Location } from '../Classes';

interface GoogleMapProps{
	className?: string,
	style?: React.CSSProperties,
	height?: number,
	location: Location,
}

var GoogleMap = (props: GoogleMapProps)=>{
	var [markerRef, marker] = useMarkerRef();
	
	return <div className="tp map-embed" style={{
		height: props.height,
	}}>
		<Map disableDefaultUI zoomControl defaultZoom={15} clickableIcons={false} defaultCenter={{ lat: props.location.lattitude, lng: props.location.longitude }} style={{
			height: props.height,
		}}>
			<Marker ref={markerRef} position={{ lat: props.location.lattitude, lng: props.location.longitude }} />
			<InfoWindow anchor={marker} maxWidth={250} headerDisabled>
				<div style={{ fontSize: 18, fontWeight: 'bold' }}>{props.location.name}</div>
				{props.location.street} {props.location.exterior_number}{props.location.interior_number ? `-${props.location.interior_number}` : ''} <br />
				{props.location.city}, {props.location.state} {props.location.zipcode}
			</InfoWindow>
		</Map>
	</div>
}

export default GoogleMap;